import React, {useEffect} from 'react';
import { Mesa, Objeto, Salon } from '../../../../../types';
import {FaTrash,FaSync, FaExclamationTriangle} from 'react-icons/fa';
import { useState } from 'react';
import { updateMesa, deleteMesa, changeMesaState, toggleVirtualByMesaId } from '../../../../../../../../crud/management_api/mesas'; // Correct import for updating Mesa
import { updateObjeto, deleteObjeto } from '../../../../../../../../crud/management_api/objectos'; // Correct import for updating Objeto
import { Dropdown } from 'react-bootstrap'; // Import Dropdown for consistent styling
import { toast } from 'react-toastify'; // Import for toast notifications
import './ItemControllers.scss'; // Correct import for styling
import Button from 'react-bootstrap/Button';
import ChangeSalon from './components/ChangeSalon/ChangeSalon';
import { FaArrowRightArrowLeft, FaRegClone } from 'react-icons/fa6';
import { DuplicarMesa } from '../../../utils';



interface ItemControllersProps {
  salones: Salon[];
  setSalones: (salones: Salon[]) => void;
  selectedItem: Mesa | Objeto | null;
  selectedSalon: Salon;
  setSelectedSalon: (salon: Salon) => void;
  setSelectedItem: (item: Mesa | Objeto | null) => void;
  updateSalon: (salon: Salon) => void;
  updateSelectedItem: (item: Mesa | Objeto) => void;
}

const ItemControllers: React.FC<ItemControllersProps> = ({
  salones,
  setSalones,
  selectedItem,
  selectedSalon,
  setSelectedSalon,
  setSelectedItem,
  updateSalon,
  updateSelectedItem
}) => {
  const [people, setPeople] = useState(selectedItem?.people || 1);
  const [tag,setTag] = useState('');
  const [status, setStatus] = useState(selectedItem?.state || false);
  const [isVirtual, setIsVirtual] = useState(false);
  const [mesaNumber, setMesaNumber] = useState(selectedItem && 'num' in selectedItem ? selectedItem.num : '');
  const [objetoName, setObjetoName] = useState(selectedItem && !('num' in selectedItem) ? selectedItem.name : '');
  const [showMoveMesaModal, setShowMoveMesaModal] = useState(false);

  // Handler cuando ChangeSalon completa el movimiento
  const handleMoveComplete = (updatedSalones?: any[]) => {
    setShowMoveMesaModal(false);
    if (updatedSalones) {
      setSalones(updatedSalones);
      const newSel = updatedSalones.find((s: any) => s.salon_id === selectedSalon?.salon_id);
      if (newSel) setSelectedSalon(newSel);
    }
    // Cerrar el panel y limpiar selección
    setSelectedItem(null);
  };

  useEffect(() => {
    if (selectedItem) {
      setPeople(selectedItem.people || 1);
      setStatus(selectedItem.state || false);
      setHeightInput(selectedItem.height?.toString() || '');
      setWidthInput(selectedItem.width?.toString() || '');
      if ('num' in selectedItem) {
        setMesaNumber(selectedItem.num);
        setIsVirtual(selectedItem.is_virtual || false);
  // Initialize tag for mesas with dynamic max length using intervals:
  // width/height <= 70 -> 2 chars
  // <= 80 -> 3 chars
  // <= 100 -> 4 chars
  // >= 110 -> 6 chars
  const initialTag = (selectedItem.tag || '').toString();
  const w = selectedItem.width;
  const h = selectedItem.height;
  let initialMax = 4; // default
  if (w <= 70 || h <= 70) initialMax = 2;
  else if (w <= 80 || h <= 80) initialMax = 3;
  else if (w <= 100 || h <= 100) initialMax = 4;
  else if (w >= 110 || h >= 110) initialMax = 6;
  setTag(initialTag.slice(0, initialMax));
      } else {
        setObjetoName(selectedItem.name);
        setIsVirtual(false);
        // Clear tag for objetos (they don't have a tag field in the type)
        setTag('');
      }
    }
  }, [selectedItem]);

  // Helper to get current tag max length based on selectedItem dimensions (intervals)
  const getTagMaxLen = (item: Mesa | Objeto | null) => {
    if (!item) return 6;
    if (!('num' in item)) return 6;
    const w = item.width;
    const h = item.height;
    // intervals: <=70 ->2, <=80 ->3, <=100 ->4, >=110 ->6, default 4
    if (w <= 70 || h <= 70) return 2;
    if (w <= 80 || h <= 80) return 3;
    if (w <= 100 || h <= 100) return 4;
    if (w >= 110 || h >= 110) return 6;
    return 4;
  };

  // Expose variables/placeholders for tag limits so it's easy to extend rules later
  const tagMaxLen = getTagMaxLen(selectedItem);
  const tagPlaceholder = `Ingrese el tag (máx ${tagMaxLen} caracteres)`;

  // State to track if user has attempted to exceed the limit
  const [showTagLimitWarning, setShowTagLimitWarning] = useState(false);
  const [showDuplicateTagWarning, setShowDuplicateTagWarning] = useState(false);
  const [showDuplicateMesaNumberWarning, setShowDuplicateMesaNumberWarning] = useState(false);
  
  // Local state for dimension inputs to allow free typing
  const [heightInput, setHeightInput] = useState(selectedItem?.height?.toString() || '');
  const [widthInput, setWidthInput] = useState(selectedItem?.width?.toString() || '');

  // Helper function to check if tag is duplicate across all mesas in all salones
  const isTagDuplicate = (tagValue: string, currentMesaId: number) => {
    if (!tagValue || tagValue.trim() === '') return false;
    
    const normalizedTag = tagValue.trim().toLowerCase();
    
    // Check all mesas in all salones
    for (const salon of salones) {
      for (const mesa of salon.mesas) {
        // Skip the current mesa being edited
        if (mesa.id === currentMesaId) continue;
        
        const mesaTag = (mesa.tag || '').toString().trim().toLowerCase();
        if (mesaTag === normalizedTag) {
          return true;
        }
      }
    }
    return false;
  };

  // Helper function to check if mesa number is duplicate across all mesas in all salones
  const isMesaNumberDuplicate = (mesaNumberValue: string, currentMesaId: number) => {
    if (!mesaNumberValue || mesaNumberValue.trim() === '') return false;
    
    const normalizedMesaNumber = mesaNumberValue.trim();
    
    // Check all mesas in all salones
    for (const salon of salones) {
      for (const mesa of salon.mesas) {
        // Skip the current mesa being edited
        if (mesa.id === currentMesaId) continue;
        
        const mesaNum = (mesa.num || '').toString().trim();
        if (mesaNum === normalizedMesaNumber) {
          return true;
        }
      }
    }
    return false;
  };

  const tagLimitBanner = showTagLimitWarning && tagMaxLen < 6 ? (
    <div className="tag-warning-banner withdrawal-tag-warning">
      <div className="tag-warning-icon"><FaExclamationTriangle /></div>
      <div className="tag-warning-content">
        <div className="tag-warning-title">Límite de caracteres</div>
        <div className="tag-warning-message">
          Con estas dimensiones solo se permitirán <span className="tag-amount-highlight">{tagMaxLen}</span> caracteres para el tag.
        </div>
      </div>
    </div>
  ) : null;

  const duplicateTagBanner = showDuplicateTagWarning ? (
    <div className="tag-warning-banner withdrawal-tag-warning">
      <div className="tag-warning-icon"><FaExclamationTriangle /></div>
      <div className="tag-warning-content">
        <div className="tag-warning-title">Tag duplicado</div>
        <div className="tag-warning-message">
          Ya existe una mesa con este tag. El tag debe ser único.
        </div>
      </div>
    </div>
  ) : null;

  const duplicateMesaNumberBanner = showDuplicateMesaNumberWarning ? (
    <div className="tag-warning-banner withdrawal-tag-warning">
      <div className="tag-warning-icon"><FaExclamationTriangle /></div>
      <div className="tag-warning-content">
        <div className="tag-warning-title">Número de mesa duplicado</div>
        <div className="tag-warning-message">
          Ya existe una mesa con este número. El número debe ser único.
        </div>
      </div>
    </div>
  ) : null;

  // Truncate tag when dimensions change or selectedItem changes
  useEffect(() => {
    const maxLen = getTagMaxLen(selectedItem);
    setTag(currentTag => {
      if (currentTag && currentTag.length > maxLen) {
        // Show warning when dimensions change and tag is too long
        setShowTagLimitWarning(true);
        return currentTag.slice(0, maxLen);
      }
      // Hide warning when changing items
      setShowTagLimitWarning(false);
      return currentTag;
    });
  }, [selectedItem?.width, selectedItem?.height, selectedItem]);


  const handleClose = () => {
    setSelectedItem(null);
  };

  const updateDimensions = (dimension: 'height' | 'width', value: number) => {
    if (!selectedItem || !selectedSalon) return;
    let updatedSalon = selectedSalon;
    let updatedSelectedItem = { ...selectedItem, [dimension]: value };
    if ('num' in selectedItem) {
      const updatedMesas = selectedSalon.mesas.map(mesa =>
        mesa.id === selectedItem.id ? { ...mesa, [dimension]: value } : mesa
      );
      updatedSalon = { ...selectedSalon, mesas: updatedMesas };
    } else {
      const updatedObjetos = selectedSalon.objetos.map(objeto =>
        objeto.id === selectedItem.id ? { ...objeto, [dimension]: value } : objeto
      );
      updatedSalon = { ...selectedSalon, objetos: updatedObjetos };
    }
    // Actualiza el estado global de salones para reflejar el cambio en tiempo real
    setSalones(
      salones.map(salon =>
        salon.salon_id === updatedSalon.salon_id ? updatedSalon : salon
      )
    );
    setSelectedSalon(updatedSalon);
    setSelectedItem(updatedSelectedItem);
    // No llamamos a updateSalon/updateSelectedItem aquí para evitar doble render
  };

  const handleSubmit = async () => {
    if (!selectedItem) return;
    
    // Validar tag duplicado antes de guardar (solo para mesas)
    if ('num' in selectedItem && tag && tag.trim()) {
      if (isTagDuplicate(tag, selectedItem.id)) {
        toast.error('No se puede guardar: El tag ya existe en otra mesa');
        setShowDuplicateTagWarning(true);
        return;
      }
    }
    
    // Validar número de mesa duplicado antes de guardar (solo para mesas)
    if ('num' in selectedItem && mesaNumber && mesaNumber.trim()) {
      if (isMesaNumberDuplicate(mesaNumber, selectedItem.id)) {
        toast.error('No se puede guardar: El número de mesa ya existe');
        setShowDuplicateMesaNumberWarning(true);
        return;
      }
    }
    
    // Mostrar toastify inmediato al hacer clic
    if ('num' in selectedItem) {
      toast.info('Guardando cambios...');
      const mesaData = {
        mesa_number: mesaNumber,
        x_position: selectedItem.x_pos,
        y_position: selectedItem.y_pos,
        width: selectedItem.width,
        height: selectedItem.height,
        people: people,
        state: status,
  // Ensure tag is trimmed and truncated to the dynamic tag max length
  tag: (tag || '').toString().trim().slice(0, tagMaxLen) || null,
      };
      updateMesa(selectedItem.id, mesaData).then((updatedMesa) => {
        toast.success('Mesa actualizada con éxito');
        // Actualizar el estado global de salones y selectedSalon con la mesa actualizada
        const updatedMesas = selectedSalon.mesas.map(mesa =>
          mesa.id === selectedItem.id ? { ...mesa, ...mesaData, num: mesaNumber } : mesa
        );
        const updatedSalon = { ...selectedSalon, mesas: updatedMesas };
        setSalones(
          salones.map(salon =>
            salon.salon_id === updatedSalon.salon_id ? updatedSalon : salon
          )
        );
        setSelectedSalon(updatedSalon);
        setSelectedItem(null);
      }).catch((error) => {
        toast.error('Error al actualizar mesa');
        console.error('Error updating mesa:', error);
      });
    } else { // Si es un Objeto
      toast.info('Actualizando objeto...');
      // Usar el valor más reciente de objetoName
      const objetoData = {
        objeto_name: objetoName,
        x_position: selectedItem.x_pos,
        y_position: selectedItem.y_pos,
        width: selectedItem.width,
        height: selectedItem.height,
        state: status,
        // Trim and truncate the tag according to the same dynamic limit
        tag: (tag || '').toString().trim().slice(0, tagMaxLen) || null,
      };
      updateObjeto(selectedItem.id, objetoData).then((updatedObjeto) => {
        toast.success('Objeto actualizado con éxito');
        // Actualizar el estado global de salones y selectedSalon con el objeto actualizado
        const updatedObjetos = selectedSalon.objetos.map(objeto =>
          objeto.id === selectedItem.id ? { ...objeto, ...objetoData, name: objetoName } : objeto
        );
        const updatedSalon = { ...selectedSalon, objetos: updatedObjetos };
        setSalones(
          salones.map(salon =>
            salon.salon_id === updatedSalon.salon_id ? updatedSalon : salon
          )
        );
        setSelectedSalon(updatedSalon);
        // Actualizar el selectedItem en tiempo real para reflejar el nuevo nombre
        setSelectedItem({ ...selectedItem, name: objetoName });
        setTimeout(() => setSelectedItem(null), 300); // Cierra el modal tras breve delay
      }).catch((error) => {
        toast.error('Error al actualizar objeto');
        console.error('Error updating objeto:', error);
      });
    }
  };

  const handleDeleteMesa = () => {
    if (!selectedItem || !('num' in selectedItem)) return;
    deleteMesa(selectedItem.id).then(() => {
      toast.success('Mesa eliminada con éxito');
      // Actualiza el array global de salones
      const updatedMesas: Mesa[] = selectedSalon.mesas.filter(mesa => mesa.id !== selectedItem.id);
      const updatedSalon = { ...selectedSalon, mesas: updatedMesas };
      setSalones(
        salones.map(salon =>
          salon.salon_id === updatedSalon.salon_id ? updatedSalon : salon
        )
      );
      setSelectedSalon(updatedSalon);
      setSelectedItem(null);
    }).catch((error) => {
      toast.error('Error al eliminar la mesa');
      console.error('Error deleting mesa:', error.response.data.message);
    });
  };
  
  const handleDeleteObjeto = () => {
    if (!selectedItem || 'num' in selectedItem) return;
    deleteObjeto(selectedItem.id).then(() => {
      toast.success('Objeto eliminado con éxito');
      // Actualiza el array global de salones
      const updatedObjetos: Objeto[] = selectedSalon.objetos.filter(objeto => objeto.id !== selectedItem.id);
      const updatedSalon = { ...selectedSalon, objetos: updatedObjetos };
      setSalones(
        salones.map(salon =>
          salon.salon_id === updatedSalon.salon_id ? updatedSalon : salon
        )
      );
      setSelectedSalon(updatedSalon);
      setSelectedItem(null);
    }).catch((error) => {
      toast.error('Error al eliminar el objeto');
      console.error('Error deleting objeto:', error.response.data.message);
    });
  };

  const handleVirtualToggle = async () => {
    if (!selectedItem || !('num' in selectedItem)) return;

    const newVirtualState = !isVirtual;
    setIsVirtual(newVirtualState);

    // If setting as virtual, automatically set tag to "MV"
    if (newVirtualState) {
      setTag('MV');
    }

    try {
      await toggleVirtualByMesaId(selectedItem.id);

      // Update local state
      const updatedMesas = selectedSalon.mesas.map(m =>
        m.id === selectedItem.id ? { 
          ...m, 
          is_virtual: newVirtualState,
          // Set tag to "MV" when making virtual
          tag: newVirtualState ? 'MV' : m.tag
        } : m
      );
      const updatedSalon = { ...selectedSalon, mesas: updatedMesas };
      setSalones(
        salones.map(salon =>
          salon.salon_id === updatedSalon.salon_id ? updatedSalon : salon
        )
      );
      setSelectedSalon(updatedSalon);
      setSelectedItem({ 
        ...selectedItem, 
        is_virtual: newVirtualState,
        tag: newVirtualState ? 'MV' : selectedItem.tag
      });

      toast.success(newVirtualState ? 'Mesa configurada como virtual' : 'Mesa ya no es virtual');
    } catch (error) {
      // Revert on error
      setIsVirtual(!newVirtualState);
      if (newVirtualState) {
        setTag(selectedItem.tag || '');
      }
      toast.error('Error actualizando estado virtual de la mesa');
      console.error('Error toggling virtual state:', error);
    }
  };

  
  const handleMesaNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!selectedItem || !('num' in selectedItem) || !selectedSalon) return;

    let newMesaNumber = e.target.value;
    // Prevenir valores negativos
    if (Number(newMesaNumber) < 0) {
      newMesaNumber = '0';
    }
    setMesaNumber(newMesaNumber);

    // Check for duplicate mesa number
    if (newMesaNumber && newMesaNumber.trim()) {
      const isDuplicate = isMesaNumberDuplicate(newMesaNumber, selectedItem.id);
      setShowDuplicateMesaNumberWarning(isDuplicate);
    } else {
      setShowDuplicateMesaNumberWarning(false);
    }

    // Update the selectedItem immediately for UI purposes
    const updatedSelectedItem = { ...selectedItem, num: newMesaNumber };
    setSelectedItem(updatedSelectedItem);

    // Update the mesas in the salon state
    const updatedMesas = selectedSalon.mesas.map(mesa =>
      mesa.id === selectedItem.id ? { ...mesa, num: newMesaNumber } : mesa
    );
    updateSalon({ ...selectedSalon, mesas: updatedMesas });
  }

  const handleObjetoNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!selectedItem || 'num' in selectedItem || !selectedSalon) return;
  
    const newObjetoName = e.target.value;
    setObjetoName(newObjetoName);
  
    // Update the selectedItem immediately for UI purposes
    const updatedSelectedItem = { ...selectedItem, name: newObjetoName };
    setSelectedItem(updatedSelectedItem);
  
    // Update the objetos in the salon state
    const updatedObjetos = selectedSalon.objetos.map(objeto =>
      objeto.id === selectedItem.id ? { ...objeto, name: newObjetoName } : objeto
    );
    updateSalon({ ...selectedSalon, objetos: updatedObjetos });
  }

  const handleStatusChange = () => {
    const newStatus = !status;  // Flip the local status
    setStatus(newStatus);
  
    if (!selectedItem || !selectedSalon) return;
  
    // If it's a Mesa
    if ('num' in selectedItem) {
      changeMesaState(selectedItem.id)
        .then(() => {
          // 1. Create a new copy of the "mesas" array with updated state
          const updatedMesas = selectedSalon.mesas.map((mesa) =>
            mesa.id === selectedItem.id ? { ...mesa, state: newStatus } : mesa
          );
          // 2. Create a NEW updatedSalon object (not mutating selectedSalon)
          const updatedSalon = { ...selectedSalon, mesas: updatedMesas };
  
          // 3. Update the entire salones array so React sees the new reference
          setSalones(
            salones.map((salon) =>
              salon.salon_id === updatedSalon.salon_id ? updatedSalon : salon
            )
          );
          // 4. Update the selectedSalon reference
          setSelectedSalon(updatedSalon);
  
          // 5. Also update the selectedItem so the UI sees the new state immediately
          setSelectedItem({ ...selectedItem, state: newStatus });
        })
        .catch((error) => {
          toast.error('Error al cambiar el estado de la mesa');
          setStatus(!newStatus); // revert local status if failed
          console.error('Error changing mesa state:', error?.response?.data?.message);
        });
    } 
    // If it's an Objeto
    else {
      // 1. Create a new copy of the "objetos" array with updated state
      const updatedObjetos = selectedSalon.objetos.map((objeto) =>
        objeto.id === selectedItem.id ? { ...objeto, state: newStatus } : objeto
      );
      // 2. Create a NEW updatedSalon object
      const updatedSalon = { ...selectedSalon, objetos: updatedObjetos };
  
      // 3. Update the entire salones array
      setSalones(
        salones.map((salon) =>
          salon.salon_id === updatedSalon.salon_id ? updatedSalon : salon
        )
      );
      // 4. Update the selectedSalon reference
      setSelectedSalon(updatedSalon);
  
      // 5. Update the selectedItem for immediate UI feedback
      setSelectedItem({ ...selectedItem, state: newStatus });
    }
  };

  return (
    <div className="item-controller-panel">
      {selectedItem && (
        <div className="panel-content">
          {/* Header with status toggle */}
          <div className="panel-header">
            <div className="header-controls">
              {/* Action buttons */}
              <div className="action-buttons-itemController">
                {'num' in selectedItem && (
                  <Button
                    className="action-btn duplicate-btn"
                    variant='none'
                    onClick={() => DuplicarMesa(
                      selectedItem,
                      selectedSalon,
                      setSelectedItem,
                      (salon) => {
                        updateSalon(salon);
                        setSalones(
                          salones.map(s =>
                            s.salon_id === salon.salon_id ? salon : s
                          )
                        );
                      },
                      setSalones,
                      salones
                    )}
                    title="Duplicar mesa"
                  >
                    <FaRegClone />
                  </Button>
                )}
                {'num' in selectedItem && (
                  <Button 
                    className="action-btn move-btn" 
                    variant='none' 
                    onClick={() => setShowMoveMesaModal(true)}
                    title="Mover a otro salón"
                  >
                    <FaArrowRightArrowLeft />
                  </Button>
                )}
                <Button 
                  className="action-btn delete-btn" 
                  variant='none' 
                  onClick={'num' in selectedItem ? handleDeleteMesa : handleDeleteObjeto}
                  title={`Eliminar ${'num' in selectedItem ? 'mesa' : 'objeto'}`}
                >
                  <FaTrash />
                </Button>
              </div>

              <div className="status-toggle">
                <span className="status-label">
                  {status ? 'Activo' : 'Inactivo'}
                </span>
                <label className="modern-switch">
                  <input
                    type="checkbox"
                    checked={status}
                    onChange={handleStatusChange}
                  />
                  <span className="switch-slider"></span>
                </label>
              </div>
            </div>
          </div>

          {/* Configuration form */}
          <div className="config-form">
            {'num' in selectedItem ? (
              <>
                <div className="form-row">
                  <div className="form-group form-group-half">
                    <label className="form-label">Número de Mesa</label>
                    <input
                      type="number"
                      min={0}
                      value={mesaNumber}
                      onChange={handleMesaNumberChange}
                      placeholder="Número"
                      className="form-input"
                    />
                  </div>
                  <div className="form-group form-group-half">
                    <label className="form-label">Tag</label>
                    <input
                      type="text"
                      value={tag}
                      maxLength={tagMaxLen}
                      onChange={e => {
                        const max = tagMaxLen;
                        const newValue = e.target.value;
                        
                        // Show warning if user tries to exceed limit
                        if (newValue.length > max) {
                          setShowTagLimitWarning(true);
                        } else {
                          // Hide warning if they're back under limit
                          if (newValue.length <= max - 1) {
                            setShowTagLimitWarning(false);
                          }
                        }
                        
                        // Check for duplicate tag
                        if (selectedItem && 'num' in selectedItem) {
                          const isDupe = isTagDuplicate(newValue, selectedItem.id);
                          setShowDuplicateTagWarning(isDupe);
                        }
                        
                        setTag(newValue.slice(0, max));
                      }}
                      placeholder={tagPlaceholder}
                      className="form-input"
                    />
                  </div>
                </div>
                {duplicateMesaNumberBanner}
                {tagLimitBanner}
                {duplicateTagBanner}
                <div className="form-group">
                  <label className="form-label">Capacidad</label>
                  <Dropdown className='capacity-dropdown'>
                    <Dropdown.Toggle variant="none" className='capacity-toggle'>
                      {people} {people <= 1 ? 'Persona' : 'Personas'}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {Array.from({ length: 15 }, (_, i) => i + 1).map(number => (
                        <Dropdown.Item key={number} onClick={() => setPeople(number)}>
                          {number} {number <= 1 ? 'Persona' : 'Personas'}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
                <div className="form-group">
                  <label className="form-label">Mesa Virtual (Caja)</label>
                  <div className="virtual-toggle-container">
                    <span className="virtual-label">
                      {isVirtual ? 'Virtual' : 'Normal'}
                    </span>
                    <label className="modern-switch">
                      <input
                        type="checkbox"
                        checked={isVirtual}
                        onChange={handleVirtualToggle}
                      />
                      <span className="switch-slider"></span>
                    </label>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="form-group">
                  <label className="form-label">Nombre del Objeto</label>
                  <input
                    type="text"
                    value={objetoName}
                    onChange={handleObjetoNameChange}
                    placeholder="Ingrese el nombre"
                    className="form-input"
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Tag</label>
                  <input
                    type="text"
                    value={tag}
                    maxLength={tagMaxLen}
                    onChange={e => {
                      const max = tagMaxLen;
                      const newValue = e.target.value;
                      
                      // Show warning if user tries to exceed limit
                      if (newValue.length > max) {
                        setShowTagLimitWarning(true);
                      } else {
                        // Hide warning if they're back under limit
                        if (newValue.length <= max - 1) {
                          setShowTagLimitWarning(false);
                        }
                      }
                      
                      // Check for duplicate tag
                      if (selectedItem && 'num' in selectedItem) {
                        const isDupe = isTagDuplicate(newValue, selectedItem.id);
                        setShowDuplicateTagWarning(isDupe);
                      }
                      
                      setTag(newValue.slice(0, max));
                    }}
                    placeholder={tagPlaceholder}
                    className="form-input"
                  />
                  {tagLimitBanner}
                  {duplicateTagBanner}
                </div>
              </>
            )}

            {/* Dimension controls */}
            <div className="dimension-controls">
              <div className="dimension-group">
                <div className="dimension-header">
                  <label className="dimension-label">Alto</label>
                  <input
                    type="number"
                    min="10"
                    max="500"
                    value={heightInput}
                    onChange={(e) => {
                      setHeightInput(e.target.value);
                      const val = Number(e.target.value);
                      if (val >= 10 && val <= 500) {
                        updateDimensions('height', val);
                      }
                    }}
                    onBlur={(e) => {
                      const val = Number(e.target.value);
                      if (val < 10 || val > 500 || !e.target.value) {
                        setHeightInput(selectedItem.height.toString());
                      }
                    }}
                    className="dimension-input"
                    placeholder="px"
                  />
                </div>
                <input
                  type="range"
                  min="10"
                  max="500"
                  value={selectedItem.height}
                  onChange={(e) => updateDimensions('height', Number(e.target.value))}
                  className="dimension-slider"
                />
              </div>
              <div className="dimension-group">
                <div className="dimension-header">
                  <label className="dimension-label">Ancho</label>
                  <input
                    type="number"
                    min="10"
                    max="500"
                    value={widthInput}
                    onChange={(e) => {
                      setWidthInput(e.target.value);
                      const val = Number(e.target.value);
                      if (val >= 10 && val <= 500) {
                        updateDimensions('width', val);
                      }
                    }}
                    onBlur={(e) => {
                      const val = Number(e.target.value);
                      if (val < 10 || val > 500 || !e.target.value) {
                        setWidthInput(selectedItem.width.toString());
                      }
                    }}
                    className="dimension-input"
                    placeholder="px"
                  />
                </div>
                <input
                  type="range"
                  min="10"
                  max="500"
                  value={selectedItem.width}
                  onChange={(e) => updateDimensions('width', Number(e.target.value))}
                  className="dimension-slider"
                />
              </div>
            </div>
          </div>

          {/* Footer buttons */}
          <div className='panel-footer'>
            <Button variant="none" className='footer-btn cancel-btn' onClick={handleClose}>
              Cancelar
            </Button>
            <Button 
              variant="none" 
              className='footer-btn save-btn' 
              onClick={handleSubmit}
              disabled={showDuplicateTagWarning || showDuplicateMesaNumberWarning}
            >
              <FaSync className="btn-icon" />
              {'num' in selectedItem ? 'Guardar' : 'Actualizar'}
            </Button>
          </div>
        </div>
      )}

      <ChangeSalon
        show={showMoveMesaModal}
        setShow={setShowMoveMesaModal}
        selectedSalon={selectedSalon}
        setSelectedSalon={setSelectedSalon}
        mesaId={selectedItem?.id || 0}
        salones={salones}
        setSalones={setSalones}
        onMoveComplete={handleMoveComplete}
      />
    </div>
  );
};

export default ItemControllers;
